import { FlashbarProps } from '@amzn/awsui-components-console/flashbar';

/**
 * The ARIA role a flash message needs to be announced by screen readers.
 * A Flashbar item with no `ariaRole` renders silently (see
 * @amzn/awsui-components-console flashbar/flash.js) — so every flash this app
 * raises must carry one.
 *
 * - error / warning → 'alert' (assertive: interrupts, heard immediately)
 * - success / info / in-progress / unset → 'status' (polite: queued)
 */
export const flashAriaRole = (
  type: FlashbarProps.Type | undefined,
): FlashbarProps.MessageDefinition['ariaRole'] =>
  type === 'error' || type === 'warning' ? 'alert' : 'status';
